import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faClockRotateLeft } from '@fortawesome/pro-light-svg-icons/faClockRotateLeft';
import { faGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe';
import { faLayerGroup } from '@fortawesome/pro-light-svg-icons/faLayerGroup';
import { faFileExport } from '@fortawesome/pro-light-svg-icons/faFileExport';
import { faLightbulb } from '@fortawesome/pro-light-svg-icons/faLightbulb';
import { faUserGroup } from '@fortawesome/pro-light-svg-icons/faUserGroup';
import { faSliders } from '@fortawesome/pro-light-svg-icons/faSliders';
import { faKey } from '@fortawesome/pro-light-svg-icons/faKey';
import { faWandMagicSparkles } from '@fortawesome/pro-light-svg-icons/faWandMagicSparkles';
import { faFileLines } from '@fortawesome/pro-light-svg-icons/faFileLines';
import { faUserPlus } from '@fortawesome/pro-light-svg-icons/faUserPlus';
import { faUsersRectangle } from '@fortawesome/pro-light-svg-icons/faUsersRectangle';
import { faShareNodes } from '@fortawesome/pro-light-svg-icons/faShareNodes';
import { faCalendarCheck } from '@fortawesome/pro-light-svg-icons/faCalendarCheck';
import { faClapperboard } from '@fortawesome/pro-light-svg-icons/faClapperboard';
import { faBrain } from '@fortawesome/pro-light-svg-icons/faBrain';
import { faGlobePointer } from '@fortawesome/pro-light-svg-icons/faGlobePointer';
import { faFileCsv } from '@fortawesome/pro-light-svg-icons/faFileCsv';
import { faBellOn } from '@fortawesome/pro-light-svg-icons/faBellOn';
import { faPalette } from '@fortawesome/pro-light-svg-icons/faPalette';
import { faCompactDisc } from '@fortawesome/pro-light-svg-icons/faCompactDisc';
import { faRotateRight } from '@fortawesome/pro-light-svg-icons/faRotateRight';
import { faFilm } from '@fortawesome/pro-light-svg-icons/faFilm';
import { faImage } from '@fortawesome/pro-light-svg-icons/faImage';
import { faFileZipper } from '@fortawesome/pro-light-svg-icons/faFileZipper';
import { faGaugeHigh } from '@fortawesome/pro-light-svg-icons/faGaugeHigh';
import { faEraser } from '@fortawesome/pro-light-svg-icons/faEraser';
import { faSackDollar } from '@fortawesome/pro-light-svg-icons/faSackDollar';
import { faChartPie } from '@fortawesome/pro-light-svg-icons/faChartPie';
import { faBolt } from '@fortawesome/pro-light-svg-icons/faBolt';
import { faSparkles } from '@fortawesome/pro-light-svg-icons/faSparkles';
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons/faPaperPlane';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faPlug } from '@fortawesome/pro-light-svg-icons/faPlug';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { SMLUpgradeFeature } from '../../config/music24PlanCapabilities';

/** One icon per feature: the upgrade prompt's icon tile (design b1) and the lock banner use it. */
export const upgradeFeatureIcons: Record<SMLUpgradeFeature, IconDefinition> = {
  [SMLUpgradeFeature.history]: faClockRotateLeft,
  [SMLUpgradeFeature.browseDepth]: faLayerGroup,
  [SMLUpgradeFeature.geography]: faGlobe,
  [SMLUpgradeFeature.musicServiceFilter]: faSliders,
  [SMLUpgradeFeature.insights]: faLightbulb,
  [SMLUpgradeFeature.csvExport]: faFileExport,
  [SMLUpgradeFeature.followLimit]: faUserGroup,
  [SMLUpgradeFeature.apiAccess]: faKey,
  [SMLUpgradeFeature.pages]: faFileLines,
  [SMLUpgradeFeature.artists]: faUserPlus,
  [SMLUpgradeFeature.seats]: faUsersRectangle,
  [SMLUpgradeFeature.socialAccounts]: faShareNodes,
  [SMLUpgradeFeature.scheduledPosts]: faCalendarCheck,
  [SMLUpgradeFeature.videoCredits]: faClapperboard,
  [SMLUpgradeFeature.aiInsights]: faBrain,
  [SMLUpgradeFeature.customDomain]: faGlobePointer,
  [SMLUpgradeFeature.fanExport]: faFileCsv,
  [SMLUpgradeFeature.presave]: faUserPlus,
  [SMLUpgradeFeature.realtimeAlerts]: faBellOn,
  [SMLUpgradeFeature.artistPortalHistory]: faClockRotateLeft,
  [SMLUpgradeFeature.earnings]: faSackDollar,
  [SMLUpgradeFeature.streamingSplit]: faChartPie,
  [SMLUpgradeFeature.releases]: faCompactDisc,
  [SMLUpgradeFeature.oldSongs]: faRotateRight,
  [SMLUpgradeFeature.fullVideo]: faFilm,
  [SMLUpgradeFeature.motionArtwork]: faImage,
  [SMLUpgradeFeature.aiFootage]: faSparkles,
  [SMLUpgradeFeature.kitLook]: faPalette,
  [SMLUpgradeFeature.kitZip]: faFileZipper,
  [SMLUpgradeFeature.renderLane]: faGaugeHigh,
  [SMLUpgradeFeature.watermark]: faEraser,
  [SMLUpgradeFeature.aiPriority]: faBolt,
  [SMLUpgradeFeature.outreach]: faPaperPlane,
  [SMLUpgradeFeature.outreachSends]: faPaperPlane,
  [SMLUpgradeFeature.outreachMailboxes]: faEnvelope,
  [SMLUpgradeFeature.outreachAutopilot]: faPlug,
  [SMLUpgradeFeature.outreachRate]: faPlug,
  [SMLUpgradeFeature.outreachExport]: faFileExport,
  [SMLUpgradeFeature.x]: faXTwitter,
  [SMLUpgradeFeature.generic]: faWandMagicSparkles,
};
